// MembershipCard (unchanged, but className is now passed dynamically)
import { useState, useEffect, useRef } from 'react';

export function MembershipCard({
  icon,
  title,
  subtitle,
  titleNote,
  className = '',
  isSelected,
  onSelect = () => {}
}) {
  const cardRef = useRef(null);
  const handleClick = () => {
    onSelect(!isSelected);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        onSelect(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onSelect]);
  return (
    <div
      ref={cardRef}
      className={`cursor-pointer bg-gradient-to-br from-slate-800 to-slate-900 p-6 w-full h-full my-10 transition-all duration-300 ${
        isSelected ? 'brightness-125' : 'brightness-100'
      } ${className}`}
      style={{
        backgroundImage: `url("/membershipBg.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        borderWidth: isSelected ? '0' : '1px',
        borderStyle: 'solid',
        borderColor: isSelected ? 'transparent' : '#47556950',
        borderRadius: '1rem',
        boxShadow: isSelected
          ? '0 0 0 1px #0098FB, 0 0 0 1px #0098FB, 0 0 0 1px #6777FF'
          : 'none',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
      onClick={handleClick}
    >
      <div className="mb-4">
        <img
          src={icon}
          alt="Membership Icon"
          className="w-6 h-6 object-contain"
        />
      </div>
     
      <div className="space-y-2">
        <h2 className="text-white text-lg font-medium">
          {title} <span className="text-gray-400">{titleNote}</span>
        </h2>
       
        <p className="text-gray-400 text-sm leading-relaxed">
          {subtitle}
        </p>
      </div>
    </div>
  );
}